module.exports = __webpack_public_path__ + "static/media/icon-application.cacade3d.svg";